/*************/
/* ANIMATION */
/*************/
// add class .toAnimate to html element with a animate.css effect class
// when on screen, the animation will execute
$(function(){
	const mutationConfig = {
		childList: true,
		subtree: true
	};
	var newAnimationObserver = new MutationObserver(domNewContent);
	newAnimationObserver.observe(document, mutationConfig);


	$(window).on('scroll load', function(event) {
		script_on_load('theme-utils', function(){
			checkAnimations();
		});
	});

	
	function domNewContent(mutations){
		mutations.forEach(function(mutation){
			if(mutation.type == 'childList'){
				let addedNodes = mutation.addedNodes;
				
				if(addedNodes.length){ // Nouveau contenu ajouté
					checkAnimations();
				}
			}
		}); 
	}


	function checkAnimations(){
		$('.toAnimate').each(function(index, el) {
			if($(this).isOnScreen() === true){
				$(this).addClass('animated').removeClass('toAnimate');
				
				var elem_class = $(this).attr('class');
				var pos = elem_class.search('animS_');
				
				if(pos !== -1){
					var anim_name = elem_class.substring(pos, elem_class.indexOf(" ", pos));
					$(this).removeClass(anim_name);
					
					anim_name = anim_name.replace('animS_', '');
					
					$(this).addClass(anim_name);
				}
			}
		});
	}
});